import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import CustomDropdown from '../../../../custom/customDropdown';
import { natpisFajlaUBazi } from '../../../../custom/datumFajla';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { FileUpload } from 'primereact/fileupload';
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { AutoComplete } from "primereact/autocomplete";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputTextarea } from 'primereact/inputtextarea';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

const VozilaUnos = () => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const toast = useRef(null);
    const formRef = useRef(null);
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const vehicle = useSelector(state => state.vehicle)
    const dispatch = useDispatch();
    const [idVehicle, setIdVehicle] = useState(null)
    /* VINJETE — zaseban deo, ne polje u "Vaznim datumima": vozilo drzi vise
       vinjeta, po jednu za svaku zemlju, pa je to spisak a ne jedan datum.
       Snima se NEZAVISNO od ostatka forme (svoja procedura), zato i ima svoje
       dugme — inace bi dodavanje vinjete tralo da se presnimi celo vozilo. */
    const [drzaveVinjeta, setDrzaveVinjeta] = useState([]);
    const [vinjete, setVinjete] = useState([]);
    const [vinjetaForma, setVinjetaForma] = useState({ id: null, id_drzava: null, DatumIsteka: null, Napomena: '' });
    const [idForFiles, setIdForFiles] = useState(null)
    const [vehicleDB, setVehicleDB] = useState(null)
    const [driverDB, setDriverDB] = useState(null)
    const [clientDB, setClientDB] = useState(null)
    const [filteredVehicle, setfilteredVehicle] = useState([]);
    const [filteredClient, setfilteredClient] = useState([])
    const [izabran, setIzabran] = useState(false)
    const [popuni, setPopuni] = useState(false)
    const [euroStandardOptions, setEuroStandardOptions] = useState(null)
    const [vrstaNadgradnjeOptions, setVrstaNadgradnjeOptions] = useState(null)
    const [vrstaVozilaOptions, setVrstaVozilaOptions] = useState(null)
    const [pogonOptions, setPogonOptions] = useState(null)
    const [tipVlasnistvaOptions, setTipVlasnistvaOptions] = useState(null)
    const [markaVozilaOptions, setMarkaVozilaOptions] = useState(null)
    const [markaVozilaPrikljucnaOptions, setMarkaVozilaPrikljucnaOptions] = useState(null)
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [porukaTimeRange, setPorukeTimeRange] = useState(null)
    const classDocumentDB = 'btnHasDocument';
    const [buttonDocumentDB, setButtonDocumentDB] = useState({
        SaobracajnaDokument: 0,
        NalepnicaDokument: 0,
        AoDokument: 0,
        ZelenaKartaDokument: 0,  
        StakloDokument: 0,  
        StrahovkaDokument: 0, 
        KaskoDokument: 0, 
        CmrDokument: 0,
        CemtBelaPotvrdaDokument: 0, 
        CemtDokument: 0, 
        IzvodLicenceDokument: 0, 
        TahoSertifikatDokument: 0,
        LpaketDokument: 0
    })

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
///DATA
const [formDataVehicle, setFormDataVehicle] = useState({
    // Podaci o vozilu
    VrstaVozila: null,                
    VrstaNadgradnje: null,                 
    EuroOznaka: null,                   
    PogonskoGorivo: null,

    Duzina: '',                       
    Sirina: '',                      
    Visina: '',

    Registracija: '',
    Marka: null,
    Model: '',
    GodinaProizvodnje: null,
    Boja: '',
    Sasija: '',
    BrojMotora: '',
    SnagaMotora: '',
    BrojOsovina: null,
    ZapreminaMotora: '',
    Masa: '',
    Nosivost: '',
    NajvecaDozvoljenaMasa: '',
    
    KapacitetRezervoara: null,
    NormiranaPotrosnja: null,
    KapacitetADBLUErez: null,
    BrojPecata: null,
    Napomena: ''
});

    const [formDataVehicleFirstReg, setFormDataVehicleFirstReg] = useState({
    PrvaRegistracijaDatum: null,     
    PrvaRegistracijaMesto: '',      
    RegistarskiBroj: '',            
    BrojSaobracajneDozvole: '',       
 
    // STARA REGISTRACIJA
    StaraRegistracija: '',    
    StaraRegistracijaIntervalOd: null,    
    StaraRegistracijaIntervalDo: null,    

    // ISTEK SAOBRACAJNE 
    IstekSaobracajne: null
    });
    const [formDataVehicleInsurance, setFormDataVehicleInsurance] = useState({
     // AO (Auto odgovornost)
    AoDatumIsteka: null,       
    AoBrojPolise: '',          
    AoPremijskiStepen: null,   
    AoCenaPolise: null,      
    
    // Zelena karta
    ZelenaKartaIstek: null,   
    ZelenaKartaBroj: '',      
    ZelenaKartaCena: null,     
    
    // Osiguranje stakla
    StakloIstek: null,        
    StakloBrojPolise: '',     
    StakloPremijskiStepen: null, 
    
    // Strahovka
    StrahovkaIstek: null,     
    StrahovkaBroj: '',         
    StrahovkaCena: null,         
    
    // Kasko
    KaskoIstek: null,        
    KaskoBrojPolise: '',       
    KaskoStete: null,            
    KaskoCena: null,             
    KaskoUcesce: null,          
    
    // CMR 
    CmrIstek: null,           
    CmrBrojPolise: '',        
    CmrStete: null,           
    CmrCena: null,               
    CmrUcesce: null,          
    });
    const [formDataVehicleImportantDates, setFormDataVehicleImportantDates] = useState({
    CemtBelaPotvrda: '',     
    CemtBelaPotvrdaVaziDo: null,             
    TirSertifikat: '',      
    TirSertifikatVaziDo: null,                
    Sestomesecni: null,                
    ObnovaTehnickog: null,                   
    // TAHO
    TahoSertifikat: null,    
    // Dokumenti
    LPaket: null,                      
    PPaparat: null,                   
    PrvaPomoc: null,   
    FRCSertifikat: null,                      
    FNXSertifikat: null,  
    Mapiranje: null,  
    Etaloniranje: null,  
    CODEXL: null  
    });
    const [formDataVehicleAdditional, setFormDataVehicleAdditional] = useState({
    ADRDatumIsteka: null,     
    PregledOpreme: '',           
    ZaduzioVozac: null,  
    // FRIGO
    FrigoUredjaj: '',                
    FrigoUredjajModel: '',                
    GodinaProizvodnjeFrigo: null,             
    SerijskiBrojFrigo: '',    

    TermoPisac: '',  
    GodinaProizvodnjePisac: null,  
    SerijskiBrojPisac: ''
    });
const [formDataVehicleProcurement, setFormDataVehicleProcurement] = useState({
    Vlasnistvo: null,
    LizingKuca: null,
    Rate: null,
    BrojLizingUgovora: '',
    DatumIstekaLizinga: null,
    NabavkaOd: null,
    Cena: null,
    IznosPDV: null,
    DatumNabavke: null,
    DatumIstekaGarancije: null,
    IstekGarancijeKm: '',
    Amortizacija: false,
    AmortizacioniKMkoficijent: null,
    AmortizacijaPoKM: ''
})
    
///FILES
    const [formDataLicenceFiles, setFormDataLicenceFiles] = useState({
        SaobracajnaDokument: [],
        NalepnicaDokument: []
    });
    const [formDataInsuranceFiles, setFormDataInsuranceFiles] = useState({
        AoDokument: [], 
        ZelenaKartaDokument: null,  
        StakloDokument: null,  
        StrahovkaDokument: null, 
        KaskoDokument: null, 
        CmrDokument: null 
    });
    const [formDataImportantDatesFiles, setFormDataImportantDatesFiles] = useState({
        CemtBelaPotvrdaDokument: null, 
        CemtDokument: null, 
        IzvodLicenceDokument: null, 
        TahoSertifikatDokument: null,
        LpaketDokument: null
    });
    
  const searchClient = (event) => {
    if(clientDB) {
        let query = event.query;

    let _filteredClient = [];
    let filteredItems = clientDB.filter(
      (item) => item.Naziv.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
    if (filteredItems && filteredItems.length) {
      _filteredClient.push(...filteredItems);
    }
    setfilteredClient(_filteredClient);
    }
    
  };

  

    useEffect(()=>{
    if(!formSubmitted){
        let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            }
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/getVehicleDataAndType", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setEuroStandardOptions(parsedData.EuroStandard)
                                setVrstaNadgradnjeOptions(parsedData.Vrsta_Nadgradnje)
                                setVrstaVozilaOptions(parsedData.Vrsta_vozila)
                                setPogonOptions(parsedData.PogonskoGorivo)
                                setTipVlasnistvaOptions(parsedData.TipVlasnistva)
                                setDriverDB(parsedData.VozaciDB)
                                setClientDB(parsedData.KlijentiDB)
                                setMarkaVozilaOptions(parsedData.MarkaVozila)
                                setMarkaVozilaPrikljucnaOptions(parsedData.MarkaVozilaPrikljucna)
                                setVehicleDB(parsedData.VozniParkDB)
                                selectVehicleFromDispatch()
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
    },[formSubmitted])

    const selectVehicleFromDispatch = () => {
      
        if(vehicle !=null){
            setIdVehicle(vehicle)
            popuniRedove()
            setIzabran(true)
        } else {
             setIzabran(false)
        }
    }

   useEffect(()=>{
        if(vehicle == null){
        resetData()
        }
   },[vehicle])

    const handleChangeDocUpload = (name, file) => {
        if(name in formDataLicenceFiles) {
            // SaobracajnaDokument / NalepnicaDokument — samo 1 dokument po koloni (novi izbor zamenjuje prethodni)
            if (file) {
                const filesArray = Array.isArray(file) ? file : [file];
                setFormDataLicenceFiles(prev => ({ ...prev, [name]: filesArray.slice(0, 1) }));
            } else {
                setFormDataLicenceFiles(prev => ({ ...prev, [name]: [] }));
            }
        }
        if (name in formDataInsuranceFiles) {
            if (name === 'AoDokument') {
                if (file) {
                    const filesArray = Array.isArray(file) ? file : [file];
                    if(filesArray.length > 5) {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_maksimalno_dozvoljeno_5_dokumenata'),
                        life: 3000,
                        });
                        setFormDataInsuranceFiles(prev => ({ ...prev, [name]: [] }));
                        return
                    }
                    setFormDataInsuranceFiles(prev => ({ 
                        ...prev, 
                        [name]: [...prev[name], ...filesArray] 
                    }));
                } else {
                    setFormDataInsuranceFiles(prev => ({ ...prev, [name]: [] }));
                }
            } else {
                setFormDataInsuranceFiles(prev => ({ ...prev, [name]: file }));
            } 
        } else if (name in formDataImportantDatesFiles) {
        setFormDataImportantDatesFiles(prev => ({ ...prev, [name]: file }));
        } 
    };
    /* ── VINJETE ──────────────────────────────────────────────────────────────
       Jedna procedura (vehicle.menadzerVinjete) i jedan endpoint za sve korake,
       pa su i ovde sve radnje na jednom mestu. */
    const vinjeteZahtev = (telo) =>
        fetch(process.env.REACT_APP_BACKEND_URL + '/vehicles/ManageVehicleVignettes', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + auth.token },
            body: JSON.stringify(telo),
        }).then(r => (r.ok ? r.json() : Promise.reject(r)));

    const ucitajVinjete = (idVoz) => {
        vinjeteZahtev({ step: 'INIT', id_vozilo: idVoz ?? null })
            .then(d => {
                setDrzaveVinjeta(d?.DrzaveDB || []);
                setVinjete(d?.VinjeteDB || []);
            })
            .catch(() => { setDrzaveVinjeta([]); setVinjete([]); });
    };

    /* Spisak drzava treba i pre nego sto je vozilo izabrano, da padajuca lista
       ne bude prazna na novom vozilu. */
    useEffect(() => { ucitajVinjete(idVehicle); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [idVehicle]);

    const resetVinjetaForme = () =>
        setVinjetaForma({ id: null, id_drzava: null, DatumIsteka: null, Napomena: '' });

    /* Klik na isti red ponistava izbor — isti obrazac kao u ostalim tabelama,
       i iskljucivo kroz dugme (bez onRowClick, koji bi okidao dvaput). */
    const izaberiVinjetu = (red) => {
        setVinjetaForma(prev => {
            if (String(prev.id) === String(red?.Izaberi)) {
                return { id: null, id_drzava: null, DatumIsteka: null, Napomena: '' };
            }
            return {
                id: red?.Izaberi ?? null,
                id_drzava: red?.id_drzava ?? null,
                DatumIsteka: red?.DatumIstekaRaw ? new Date(red.DatumIstekaRaw) : null,
                Napomena: red?.Napomena || '',
            };
        });
    };

    const sacuvajVinjetu = () => {
        if (!idVehicle) {
            toast.current.show({ severity: 'warn', summary: t('admin.vinjetaBezVozila'), life: 3000 });
            return;
        }
        if (!vinjetaForma.id_drzava || !vinjetaForma.DatumIsteka) {
            toast.current.show({ severity: 'warn', summary: t('admin.vinjetaNepotpuna'), life: 3000 });
            return;
        }
        vinjeteZahtev({
            step: 'SAVE',
            id: vinjetaForma.id,
            id_vozilo: idVehicle,
            id_drzava: vinjetaForma.id_drzava,
            /* toUtcIso, inace bi datum u ponoc po Beogradu otisao dan unazad. */
            DatumIsteka: toUtcIso(vinjetaForma.DatumIsteka),
            Napomena: vinjetaForma.Napomena || null,
        })
            .then(d => {
                toast.current.show({
                    severity: d?.message && d.message.indexOf('Nema izmena') === 0 ? 'info' : 'success',
                    summary: d?.message || '', life: 3000,
                });
                resetVinjetaForme();
                ucitajVinjete(idVehicle);
            })
            .catch(() => toast.current.show({ severity: 'error', summary: 'Error', life: 3000 }));
    };

    const obrisiVinjetu = () => {
        if (!vinjetaForma.id) return;
        confirmDialog({
            message: t('admin.vinjetaBrisanje'),
            acceptLabel: t('common.yes'),
            rejectLabel: t('common.no'),
            icon: 'pi pi-info-circle',
            acceptClassName: 'p-button-danger',
            accept: () => vinjeteZahtev({ step: 'DELETE', id: vinjetaForma.id, id_vozilo: idVehicle })
                .then(d => {
                    toast.current.show({ severity: 'success', summary: d?.message || '', life: 3000 });
                    resetVinjetaForme();
                    ucitajVinjete(idVehicle);
                })
                .catch(() => toast.current.show({ severity: 'error', summary: 'Error', life: 3000 })),
        });
    };

    const handleVehicleChange = (e) => {
        let { name, value, checked } = e.target;

        if (name in formDataVehicle) {
            if(name == "VrstaVozila"){
                setFormDataVehicle(prev => ({ ...prev, [name]: value }));
                setFormDataVehicle(prev => ({ ...prev, ["VrstaNadgradnje"]: null }));
                setFormDataVehicle(prev => ({ ...prev, ["EuroOznaka"]: null }));
                if(value == 10 || value == 12 || value == 15 || value == 16 ){
                    setFormDataVehicleInsurance(prev => ({ ...prev, ["CmrIstek"]: null }));
                    setFormDataVehicleInsurance(prev => ({ ...prev, ["CmrBrojPolise"]: null }));
                    setFormDataVehicleInsurance(prev => ({ ...prev, ["CmrStete"]: null }));
                    setFormDataVehicleInsurance(prev => ({ ...prev, ["CmrCena"]: null }));
                    setFormDataVehicleInsurance(prev => ({ ...prev, ["CmrUcesce"]: null })); 
                    setFormDataInsuranceFiles(prev => ({ ...prev, ["CmrDokument"]: null }));  
                }
                if(formDataVehicle.VrstaVozila != 10 || formDataVehicle.VrstaVozila != 12) {
                    
                    setFormDataImportantDatesFiles(prev => ({ ...prev, ["TahoSertifikatDokument"]: null }));
                    setFormDataImportantDatesFiles(prev => ({ ...prev, ["LpaketDokument"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["TahoSertifikat"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["LPaket"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["PPaparat"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["PrvaPomoc"]: null }));
                     
                } else {
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["FRCSertifikat"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["FNXSertifikat"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["Mapiranje"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["Etaloniranje"]: null }));
                    setFormDataVehicleImportantDates(prev => ({ ...prev, ["CODEXL"]: null }));
                }
            } else {
        setFormDataVehicle(prev => ({ ...prev, [name]: value }));}
        } else if (name in formDataVehicleFirstReg) {   
            if(name == 'StaraRegistracijaIntervalDo'){
                if(formDataVehicleFirstReg.StaraRegistracijaIntervalOd >= value) {
                    setFormDataVehicleFirstReg(prev => ({ ...prev, StaraRegistracijaIntervalDo: null }));
                    setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                    return
                } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
                }
            }
            setFormDataVehicleFirstReg(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataVehicleInsurance) {
            /* Rok za sestomesecni se racuna JEDINO iz AO osiguranja — sest
               meseci pre njegovog isteka. Datum obavljenog tehnickog pregleda
               ga namerno ne dira. */
            if(name == "AoDatumIsteka") {
                const sestomesecni = new Date(value);
                sestomesecni.setMonth(sestomesecni.getMonth() - 6);
                // Add the new variable to your data object
                setFormDataVehicleImportantDates(prev => ({ ...prev, ["Sestomesecni"]: sestomesecni}));
                setFormDataVehicleImportantDates(prev => ({ ...prev, ["ObnovaTehnickog"]: null }));
            }
        setFormDataVehicleInsurance(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataVehicleImportantDates) {
        setFormDataVehicleImportantDates(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataVehicleAdditional) {
        setFormDataVehicleAdditional(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataVehicleProcurement) {
            if(name === 'Amortizacija') {
                setFormDataVehicleProcurement(prev => ({ ...prev, ['Amortizacija']: checked }));
                setFormDataVehicleProcurement(prev => ({ ...prev, ['AmortizacioniKMkoficijent']: null }));
                setFormDataVehicleProcurement(prev => ({ ...prev, ['AmortizacijaPoKM']: null }));
            } else if (name === 'AmortizacioniKMkoficijent') {
                setFormDataVehicleProcurement(prev => ({ ...prev, ['AmortizacijaPoKM']: null }));
                setFormDataVehicleProcurement(prev => ({ ...prev, [name]: value }));
            } else if (name === 'AmortizacijaPoKM') {
                setFormDataVehicleProcurement(prev => ({ ...prev, ['AmortizacioniKMkoficijent']: null }));
                setFormDataVehicleProcurement(prev => ({ ...prev, [name]: value }));
            } else {
                if(name == 'Vlasnistvo' && value == 58) {
                    if(formDataVehicleProcurement.LizingKuca != null) {
                        setFormDataVehicleProcurement(prev => ({ ...prev, ['LizingKuca']: null }));
                    } 
                    if(formDataVehicleProcurement.Rate != null) {
                        setFormDataVehicleProcurement(prev => ({ ...prev, ['Rate']: null })); 
                    } 
                    if(formDataVehicleProcurement.BrojLizingUgovora != null) {
                        setFormDataVehicleProcurement(prev => ({ ...prev, ['BrojLizingUgovora']: null })); 
                    } 
                    if(formDataVehicleProcurement.DatumIstekaLizinga != null) {
                        setFormDataVehicleProcurement(prev => ({ ...prev, ['DatumIstekaLizinga']: null })); 
                    } 
                }

                setFormDataVehicleProcurement(prev => ({ ...prev, [name]: value }));
            }
        } 
    };
   
    const popuniStavke = (apiData) => {

    setButtonDocumentDB({
        SaobracajnaDokument: apiData[0].SaobracajnaDokument || 0,
        NalepnicaDokument: apiData[0].NalepnicaDokument || 0,
        AoDokument: apiData[0].AoDokument || 0,
        ZelenaKartaDokument: apiData[0].ZelenaKartaDokument || 0,
        StakloDokument: apiData[0].StakloDokument || 0,  
        StrahovkaDokument: apiData[0].StrahovkaDokument || 0, 
        KaskoDokument: apiData[0].KaskoDokument || 0, 
        CmrDokument: apiData[0].CmrDokument || 0,
        CemtBelaPotvrdaDokument: apiData[0].CemtBelaPotvrdaDokument || 0, 
        CemtDokument: apiData[0].CemtDokument || 0, 
        IzvodLicenceDokument: apiData[0].IzvodLicenceDokument || 0, 
        TahoSertifikatDokument: apiData[0].TahoSertifikatDokument || 0,
        LpaketDokument: apiData[0].LpaketDokument || 0
    })

     
    setFormDataVehicle({
        VrstaVozila: parseInt(apiData[0].VrstaVozila?.toString()) || null,
        VrstaNadgradnje: parseInt(apiData[0].VrstaNadgradnje?.toString()) || null,
        EuroOznaka: parseInt(apiData[0].EuroOznaka?.toString()) || null,
        PogonskoGorivo: parseInt(apiData[0].PogonskoGorivo?.toString()) || null,
        // DIMENZIJE VOZILA
        Duzina: apiData[0].Duzina || '',
        Sirina: apiData[0].Sirina || '',
        Visina: apiData[0].Visina || '',
        Registracija: apiData[0].Registracija || '',
        Marka: apiData[0].Marka || '',
        Model: apiData[0].Model || '',
        GodinaProizvodnje: apiData[0].GodinaProizvodnje ? new Date(apiData[0].GodinaProizvodnje) : null,
        Boja: apiData[0].Boja || '',
        Sasija: apiData[0].Sasija || '',
        BrojMotora: apiData[0].BrojMotora || '',
        SnagaMotora: apiData[0].SnagaMotora || '',
        BrojOsovina: apiData[0].BrojOsovina || '',
        ZapreminaMotora: apiData[0].ZapreminaMotora || '',
        Masa: apiData[0].Masa || '',
        Nosivost: apiData[0].Nosivost || '',
        NajvecaDozvoljenaMasa: apiData[0].NajvecaDozvoljenaMasa || '',
        
        KapacitetRezervoara: apiData[0].KapacitetRezervoara || null,
        NormiranaPotrosnja: apiData[0].NormiranaPotrosnja || null,
        KapacitetADBLUErez: apiData[0].KapacitetADBLUErez || null,
        BrojPecata: apiData[0].BrojPecata ?? null,
        Napomena: apiData[0].Napomena || ''
    });


    // FIrstReg
    setFormDataVehicleFirstReg({
        PrvaRegistracijaDatum: apiData[0].PrvaRegistracijaDatum ? new Date(apiData[0].PrvaRegistracijaDatum) : null,
        PrvaRegistracijaMesto: apiData[0].PrvaRegistracijaMesto || '',
        RegistarskiBroj: apiData[0].RegistarskiBroj || '',
        BrojSaobracajneDozvole: apiData[0].BrojSaobracajneDozvole || '',
        
        // STARA REGISTRACIJA
        StaraRegistracija: apiData[0].StaraRegistracija || '',
        StaraRegistracijaIntervalOd: apiData[0].StaraRegistracijaIntervalOd ? new Date(apiData[0].StaraRegistracijaIntervalOd) : null,   
        StaraRegistracijaIntervalDo: apiData[0].StaraRegistracijaIntervalDo ? new Date(apiData[0].StaraRegistracijaIntervalDo) : null,     

        //ISTEK SAOB
        IstekSaobracajne: apiData[0].IstekSaobracajne ? new Date(apiData[0].IstekSaobracajne) : null,   
        });

    // CPC
    setFormDataVehicleInsurance({
    AoDatumIsteka: apiData[0].AoDatumIsteka ? new Date(apiData[0].AoDatumIsteka) : null,
    AoBrojPolise: apiData[0].AoBrojPolise || '',
    AoPremijskiStepen: apiData[0].AoPremijskiStepen || null,
    AoCenaPolise: apiData[0].AoCenaPolise || null,
    
    // Zelena karta
    ZelenaKartaIstek: apiData[0].ZelenaKartaIstek ? new Date(apiData[0].ZelenaKartaIstek) : null,
    ZelenaKartaBroj: apiData[0].ZelenaKartaBroj || '',
    ZelenaKartaCena: apiData[0].ZelenaKartaCena || null,
    // Osiguranje stakla
    StakloIstek: apiData[0].StakloIstek ? new Date(apiData[0].StakloIstek) : null,
    StakloBrojPolise: apiData[0].StakloBrojPolise || '',
    StakloPremijskiStepen: apiData[0].StakloPremijskiStepen || null,
    // Strahovka
    StrahovkaIstek: apiData[0].StrahovkaIstek ? new Date(apiData[0].StrahovkaIstek) : null,
    StrahovkaBroj: apiData[0].StrahovkaBroj || '',
    StrahovkaCena: apiData[0].StrahovkaCena || null,
    // Kasko
    KaskoIstek: apiData[0].KaskoIstek ? new Date(apiData[0].KaskoIstek) : null,
    KaskoBrojPolise: apiData[0].KaskoBrojPolise || '',
    KaskoStete: apiData[0].KaskoStete || null,
    KaskoCena: apiData[0].KaskoCena || null,
    KaskoUcesce: apiData[0].KaskoUcesce || null,
    // CMR 
    CmrIstek: apiData[0].CmrIstek ? new Date(apiData[0].CmrIstek) : null,
    CmrBrojPolise: apiData[0].CmrBrojPolise || '',
    CmrStete: apiData[0].CmrStete || null,
    CmrCena: apiData[0].CmrCena || null,
    CmrUcesce: apiData[0].CmrUcesce || null,
    });

    setFormDataVehicleImportantDates({
        CemtBelaPotvrda: apiData[0].CemtBelaPotvrda || '',
        CemtBelaPotvrdaVaziDo: apiData[0].CemtBelaPotvrdaVaziDo ? new Date(apiData[0].CemtBelaPotvrdaVaziDo) : null,
        TirSertifikat: apiData[0].TirSertifikat || '',
        TirSertifikatVaziDo: apiData[0].TirSertifikatVaziDo ? new Date(apiData[0].TirSertifikatVaziDo) : null,
        Sestomesecni: apiData[0].Sestomesecni ? new Date(apiData[0].Sestomesecni) : null,
        ObnovaTehnickog: apiData[0].ObnovaTehnickog ? new Date(apiData[0].ObnovaTehnickog) : null,
        TahoSertifikat: apiData[0].TahoSertifikat ? new Date(apiData[0].TahoSertifikat) : null,
        LPaket: apiData[0].LPaket ? new Date(apiData[0].LPaket) : null,
        PPaparat: apiData[0].PPaparat ? new Date(apiData[0].PPaparat) : null,
        PrvaPomoc: apiData[0].PrvaPomoc ? new Date(apiData[0].PrvaPomoc) : null,
        FRCSertifikat: apiData[0].FRCSertifikat ? new Date(apiData[0].FRCSertifikat) : null,
        FNXSertifikat: apiData[0].FNXSertifikat ? new Date(apiData[0].FNXSertifikat) : null,
        Mapiranje: apiData[0].Mapiranje ? new Date(apiData[0].Mapiranje) : null,
        Etaloniranje: apiData[0].Etaloniranje ? new Date(apiData[0].Etaloniranje) : null,
        CODEXL: apiData[0].CODEXL ? new Date(apiData[0].CODEXL) : null
    });
   setFormDataVehicleAdditional({
    ADRDatumIsteka: apiData[0].ADRDatumIsteka || null,     
    PregledOpreme: apiData[0].PregledOpreme || '',
    ZaduzioVozac: apiData[0].ZaduzioVozac || null, 
    // FRIGO
    FrigoUredjaj: apiData[0].FrigoUredjaj || '',                   
    FrigoUredjajModel: apiData[0].FrigoUredjajModel || '',    
    GodinaProizvodnjeFrigo: apiData[0].GodinaProizvodnjeFrigo ? new Date(apiData[0].GodinaProizvodnjeFrigo) : null,
    SerijskiBrojFrigo: apiData[0].SerijskiBrojFrigo || '',    

    TermoPisac: apiData[0].TermoPisac || '',
    GodinaProizvodnjePisac: apiData[0].GodinaProizvodnjePisac ? new Date(apiData[0].GodinaProizvodnjePisac) : null,  
    SerijskiBrojPisac: apiData[0].SerijskiBrojPisac || ''
    });

    let LizingObject = null;
    if (apiData[0].LizingKuca) {
    const cleanStringLizing = apiData[0].LizingKuca.trim().replace(/^"|"$/g, '');
    try {
        LizingObject = JSON.parse(cleanStringLizing);
    } catch (e) {
        console.error('Greška u parsiranju LizingKuca:', e);
    }
    }

    let NabavkaOdObject = null;
    if (apiData[0].NabavkaOd) {
    const cleanStringNabavkaOd = apiData[0].NabavkaOd.trim().replace(/^"|"$/g, '');
    try {
        NabavkaOdObject = JSON.parse(cleanStringNabavkaOd);
    } catch (e) {
        console.error('Greška u parsiranju NabavkaOd:', e);
    }
}

    setFormDataVehicleProcurement({
    Vlasnistvo: apiData[0].Vlasnistvo || null,     
    LizingKuca: LizingObject || null,
    Rate: apiData[0].Rate || null,  
    BrojLizingUgovora: apiData[0].BrojLizingUgovora || '', 
    DatumIstekaLizinga: apiData[0].DatumIstekaLizinga ? new Date(apiData[0].DatumIstekaLizinga) : null,
    NabavkaOd: NabavkaOdObject || null,                  
    Cena: apiData[0].Cena || null,    
    IznosPDV: apiData[0].IznosPDV || null,
    DatumNabavke: apiData[0].DatumNabavke ? new Date(apiData[0].DatumNabavke) : null,  
    DatumIstekaGarancije: apiData[0].DatumIstekaGarancije ? new Date(apiData[0].DatumIstekaGarancije) : null,  
    IstekGarancijeKm: apiData[0].IstekGarancijeKm || '',
    Amortizacija: apiData[0].Amortizacija || false,
    AmortizacioniKMkoficijent: apiData[0].AmortizacioniKMkoficijent || null,
    AmortizacijaPoKM: apiData[0].AmortizacijaPoKM || ''
    });

};

    /* prima izbor iz dropdowna; bez argumenta radi po redux vrednosti */
    const popuniRedove = async (izbor) => {

        const izabrano = izbor || vehicle;

        if(izabrano){
             setPopuni(true);
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: izabrano
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/FillInVehicleData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                              if(data && data.length > 0) {
                                popuniStavke(data)
                              } else {
                                if(izabrano)
                                dispatch({type: "VEHICLE",value: null });

                                  toast.current.show({
                                    severity: "info",
                                    summary: t('admin.m_obavestenje_1'),
                                    detail: t('admin.m_pasivno_vozilo'),
                                    life: 3000,
                                });
                              }
                              
                    
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        } else {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_vozilo_da_bi_popunili_pod'),
                        life: 3000,
                    });
        }
    }
    const handleUploadAndSaveFiles = async (id)=> {
              
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "vozila");

                                            Object.entries(formDataInsuranceFiles).forEach(([key, value]) => {
                                                if (value) {
                                                    if (Array.isArray(value)) {
                                                        value.forEach(file => {
                                                            formData.append(key, file);
                                                        });
                                                    } else {
                                                        formData.append(key, value);
                                                    }
                                                }
                                            });

                                            Object.entries(formDataLicenceFiles).forEach(([key, value]) => {
                                                if (value) {
                                                    if (Array.isArray(value)) {
                                                        value.forEach(file => {
                                                            formData.append(key, file);
                                                        });
                                                    } else {
                                                        formData.append(key, value);
                                                    }
                                                }
                                            });

                                            Object.entries(formDataImportantDatesFiles).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/InsertVehicleFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
                                                    setIdForFiles(false)
                                                    setIzabran(false)
                                                    setPopuni(false)
                                                    resetData()
                                                    resetDataFiles()
                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                error.json().then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage.message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })
                                 
    }
const resetData = ()=> {

    setButtonDocumentDB({
        SaobracajnaDokument: 0,
        NalepnicaDokument: 0,
        AoDokument: 0,
        ZelenaKartaDokument: 0,
        StakloDokument: 0,  
        StrahovkaDokument: 0, 
        KaskoDokument: 0, 
        CmrDokument: 0,
        CemtBelaPotvrdaDokument: 0, 
        CemtDokument: 0, 
        IzvodLicenceDokument: 0, 
        TahoSertifikatDokument: 0,
        LpaketDokument: 0
    })

        setFormDataVehicle({
        VrstaVozila: null,  
        VrstaNadgradnje: null,                   
        EuroOznaka: null,      
        PogonskoGorivo: null,
        // DIMENZIJE VOZILA
        Duzina: '',                     
        Sirina: '',                      
        Visina: '',
        Registracija: '',
        Marka: null,
        Model: '',
        GodinaProizvodnje: null,
        Boja: '',
        Sasija: '',
        BrojMotora: '',
        SnagaMotora: '',
        BrojOsovina: '',
        ZapreminaMotora: '',
        Masa: '',
        Nosivost: '',
        NajvecaDozvoljenaMasa: '',
        KapacitetRezervoara: null,
        NormiranaPotrosnja: null,
        KapacitetADBLUErez: null,
        BrojPecata: null,
        Napomena: ''
    });
    setFormDataVehicleFirstReg({
        PrvaRegistracijaDatum: null,      
        PrvaRegistracijaMesto: '',       
        RegistarskiBroj: '',             
        BrojSaobracajneDozvole: '',       
        
        // STARA REGISTRACIJA
        StaraRegistracija: '',    
        StaraRegistracijaIntervalOd: null,   
        StaraRegistracijaIntervalDo: null,
        // ISTEK SAOBRACAJNE
        IstekSaobracajne: null

        });
    setFormDataVehicleInsurance({
     // AO (Auto odgovornost)
     AoDatumIsteka: null,       
    AoBrojPolise: '',          
    AoPremijskiStepen: null,    
    AoCenaPolise: null,          
    
    // Zelena karta
    ZelenaKartaIstek: null,    
    ZelenaKartaBroj: '',       
    ZelenaKartaCena: null,      
    
    // Osiguranje stakla
    StakloIstek: null,        
    StakloBrojPolise: '',      
    StakloPremijskiStepen: null, 
    
    // Strahovka
    StrahovkaIstek: null,      
    StrahovkaBroj: '',         
    StrahovkaCena: null,         
    
    // Kasko
    KaskoIstek: null,         
    KaskoBrojPolise: '',       
    KaskoStete: null,           
    KaskoCena: null,             
    KaskoUcesce: null,           
    
    // CMR 
    CmrIstek: null,            
    CmrBrojPolise: '',       
    CmrStete: null,             
    CmrCena: null,             
    CmrUcesce: null,             
    });

    setFormDataVehicleImportantDates({
    CemtBelaPotvrda: '',     
    CemtBelaPotvrdaVaziDo: null,            
    TirSertifikat: '',      
    TirSertifikatVaziDo: null,                 
    Sestomesecni: null,                
    ObnovaTehnickog: null,                 
    // TAHO
    TahoSertifikat: null,    
    // Dokumenti
    LPaket: null,                      
    PPaparat: null,                     
    PrvaPomoc: null,   
    FRCSertifikat: null,                     
    FNXSertifikat: null,  
    Mapiranje: null,  
    Etaloniranje: null,  
    CODEXL: null  
    });
    setFormDataVehicleAdditional({
   ADRDatumIsteka: null,     
    PregledOpreme: '',             
    ZaduzioVozac: null,  
    // FRIGO
    FrigoUredjaj: '',               
    FrigoUredjajModel: '',           
    GodinaProizvodnjeFrigo: null,        
    SerijskiBrojFrigo: '',    

    TermoPisac: '',  
    GodinaProizvodnjePisac: null,  
    SerijskiBrojPisac: ''
    });
    setFormDataVehicleProcurement({
    Vlasnistvo: null,
    LizingKuca: null,
    Rate: null,
    BrojLizingUgovora: '',
    DatumIstekaLizinga: null,
    NabavkaOd: null,
    Cena: null,
    IznosPDV: null,
    DatumNabavke: null,
    DatumIstekaGarancije: null,
    IstekGarancijeKm: '',
    Amortizacija: false,
    AmortizacioniKMkoficijent: null,
    AmortizacijaPoKM: ''
})
}

const resetDataFiles=()=>{
     setFormDataInsuranceFiles({
        AoDokument: [],
        ZelenaKartaDokument: null,
        StakloDokument: null, 
        StrahovkaDokument: null, 
        KaskoDokument: null,
        CmrDokument: null 
    });
    setFormDataImportantDatesFiles({
        CemtBelaPotvrdaDokument: null,
        CemtDokument: null,
        IzvodLicenceDokument: null,
        TahoSertifikatDokument: null,
        LpaketDokument: null
    });
    setFormDataLicenceFiles({
        SaobracajnaDokument: [],
        NalepnicaDokument: [],
    })
}
 const handleFormSubmit = (e) => {

            e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    handleUploadAndSave()
 }
        const handleUploadAndSave = () => {
       
            confirmDialog({
            message: "Jel ste sigurni da želite nastaviti sa unosom?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptInsert,
            reject: rejectInsert,
            });

    };

     
    function toUtcIso(d) {
        if (!d) return null;
        const x = d instanceof Date ? d : new Date(d);
        const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
        return utc.toISOString().slice(0, 19) + 'Z';
    }

    const acceptInsert = async () => {


            const hasAnyValuesInsuranceFiles = Object.values(formDataInsuranceFiles).some(value => {
                if (value === null || value === '') return false;
                
                if (value instanceof Date && isNaN(value.getTime())) return false;
                
                if (Array.isArray(value)) {
                    return value.length > 0 && value.some(item => item !== null && item !== '');
                }
    
                return true;
            });
            const hasAnyValuesLicenceFiles = Object.values(formDataLicenceFiles).some(value => {
                if (value === null || value === '') return false;
                
                if (value instanceof Date && isNaN(value.getTime())) return false;
                
                if (Array.isArray(value)) {
                    return value.length > 0 && value.some(item => item !== null && item !== '');
                }
    
                return true;
            });
            const hasAnyValueImportantDatesFiles = Object.values(formDataImportantDatesFiles).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });
            //DATA
                const hasAnyValueVehicle = Object.values(formDataVehicle).some(value => {
                if (value === null || value === '') return false;

                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
              const hasAnyValueVehicleFirstReg = Object.values(formDataVehicleFirstReg).some((value) => {
                if (value === null || value === '') return false;

                if (value instanceof Date) {
                    return !isNaN(value.getTime());
                }

                if (value instanceof File || value instanceof Blob) {
                    return value.size > 0;
                }

                return true;
                });
                const hasAnyValueVehicleInsurance = Object.values(formDataVehicleInsurance).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
            const hasAnyValueImportantDates = Object.values(formDataVehicleImportantDates).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
             const hasAnyValueAdditional = Object.values(formDataVehicleAdditional).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
                 const hasAnyValueProcurement = Object.values(formDataVehicleProcurement).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
                    
                const payload = {
                        ...formDataVehicle,
                        GodinaProizvodnje: toUtcIso(formDataVehicle.GodinaProizvodnje)
                        };  
                  const payload1 = {
                        ...formDataVehicleFirstReg,
                        PrvaRegistracijaDatum: toUtcIso(formDataVehicleFirstReg.PrvaRegistracijaDatum),
                        StaraRegistracijaIntervalOd: toUtcIso(formDataVehicleFirstReg.StaraRegistracijaIntervalOd),
                        StaraRegistracijaIntervalDo: toUtcIso(formDataVehicleFirstReg.StaraRegistracijaIntervalDo),
                        IstekSaobracajne: toUtcIso(formDataVehicleFirstReg.IstekSaobracajne)
                        };
                    const payload2 = {
                        ...formDataVehicleInsurance,
                        AoDatumIsteka: toUtcIso(formDataVehicleInsurance.AoDatumIsteka),
                        ZelenaKartaIstek: toUtcIso(formDataVehicleInsurance.ZelenaKartaIstek),
                        StakloIstek: toUtcIso(formDataVehicleInsurance.StakloIstek),
                        StrahovkaIstek: toUtcIso(formDataVehicleInsurance.StrahovkaIstek),
                        KaskoIstek: toUtcIso(formDataVehicleInsurance.KaskoIstek),
                        CmrIstek: toUtcIso(formDataVehicleInsurance.CmrIstek)
                        };    
                     const payload3 = {
                        ...formDataVehicleImportantDates,
                        CemtBelaPotvrdaVaziDo: toUtcIso(formDataVehicleImportantDates.CemtBelaPotvrdaVaziDo),
                        TirSertifikatVaziDo: toUtcIso(formDataVehicleImportantDates.TirSertifikatVaziDo),
                        Sestomesecni: toUtcIso(formDataVehicleImportantDates.Sestomesecni),
                        ObnovaTehnickog: toUtcIso(formDataVehicleImportantDates.ObnovaTehnickog),
                        TahoSertifikat: toUtcIso(formDataVehicleImportantDates.TahoSertifikat),
                        LPaket: toUtcIso(formDataVehicleImportantDates.LPaket),
                        PPaparat: toUtcIso(formDataVehicleImportantDates.PPaparat),
                        PrvaPomoc: toUtcIso(formDataVehicleImportantDates.PrvaPomoc),
                        FRCSertifikat: toUtcIso(formDataVehicleImportantDates.FRCSertifikat),
                        FNXSertifikat: toUtcIso(formDataVehicleImportantDates.FNXSertifikat),
                        Mapiranje: toUtcIso(formDataVehicleImportantDates.Mapiranje),
                        Etaloniranje: toUtcIso(formDataVehicleImportantDates.Etaloniranje),
                        CODEXL: toUtcIso(formDataVehicleImportantDates.CODEXL)
                        };    
                     const payload4 = {
                        ...formDataVehicleAdditional,
                        ADRDatumIsteka: toUtcIso(formDataVehicleAdditional.ADRDatumIsteka)
                        };  
                     const payload5 = {
                        ...formDataVehicleProcurement,
                        DatumIstekaLizinga: toUtcIso(formDataVehicleProcurement.DatumIstekaLizinga),
                        DatumNabavke: toUtcIso(formDataVehicleProcurement.DatumNabavke),
                        DatumIstekaGarancije: toUtcIso(formDataVehicleProcurement.DatumIstekaGarancije)
                        };    


            if(izabran && popuni){
                 if(hasAnyValueVehicle || hasAnyValueVehicleFirstReg || hasAnyValueVehicleInsurance || hasAnyValueImportantDates || hasAnyValueAdditional|| hasAnyValueProcurement){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idVehicle,
                                formDataVehicle: payload,
                                formDataVehicleFirstReg: payload1,
                                formDataVehicleInsurance: payload2,
                                formDataVehicleImportantDates: payload3,
                                formDataVehicleAdditional: payload4,
                                formDataVehicleProcurement: payload5
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/UpdateVehicle", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                               
                               
                                setIdForFiles(idVehicle)
                                setIzabran(null)
                                setPopuni(null)
                                if((idVehicle) && (hasAnyValuesInsuranceFiles || hasAnyValueImportantDatesFiles || hasAnyValuesLicenceFiles)) {
                                handleUploadAndSaveFiles(idVehicle)
                                }
                                setIdVehicle(null)
                                resetData()
                                resetDataFiles()
                                setFormSubmitted(false)
                                 if(data[0].message){   
                                    toast.current.show({
                                    severity: "warn",
                                    summary: t('admin.m_obavestenje'),
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                }  else {
                                 toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_vozila'),
                                life: 3000,
                                });
                                }
                       
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_vozila_za_unos'),
                        life: 3000,
                    });
                }
           
           
            } else {
                

                if(hasAnyValueVehicle || hasAnyValueVehicleFirstReg || hasAnyValueVehicleInsurance || hasAnyValueImportantDates || hasAnyValueAdditional || hasAnyValueProcurement){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formDataVehicle,
                                formDataVehicleFirstReg: payload1,
                                formDataVehicleInsurance: payload2,
                                formDataVehicleImportantDates: payload3,
                                formDataVehicleAdditional: payload4,
                                formDataVehicleProcurement: payload5
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/vehicles/InsertVehicle", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                resetData()
                                setIdForFiles(data.id)
                                setIzabran(false)
                                setPopuni(false)
                                if((data.id || idForFiles) && (hasAnyValuesInsuranceFiles || hasAnyValueImportantDatesFiles || hasAnyValuesLicenceFiles)) {
            
                                handleUploadAndSaveFiles(data.id || idForFiles)
                                }
                                setFormSubmitted(false)
                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesan_unos_podataka_vozila'),
                                life: 3000,
                                });
                              
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_vozila_za_unos'),
                        life: 3000,
                    });
                }
            }

  };
           

  const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };

  const selectIdVehicleFUNC = (e) => {
        const izabrano = e.target.value;
        dispatch({ type: "VEHICLE", value: izabrano == undefined ? null : izabrano });

        if (izabrano == undefined) {
            setIzabran(false);
            setPopuni(false);
            resetData();
            resetDataFiles();
        } else {
            setIzabran(true);
            setIdVehicle(izabrano);
            popuniRedove(izabrano);   // podaci se ucitavaju odmah, bez dugmeta
        }
};

const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};

const selectLizingKucaFUNC = (e) => {
    setFormDataVehicleProcurement(prev => ({ ...prev, ['LizingKuca']: e.value }));
    };
const selectNabavkaOdFUNC = (e) => {
    setFormDataVehicleProcurement(prev => ({ ...prev, ['NabavkaOd']: e.value }));
    };

    const resetDispatchVehicle = () => {
          dispatch({
                type: "VEHICLE",
                value: null
                        });
    }

  const handleSelect = () => {
    if (idVehicle) {  // resetuj samo ako ima vrednost
        setIdVehicle(null)
        setIzabran(false)
        setPopuni(false)
        resetDispatchVehicle()
        resetData()
        resetDataFiles()
    }
   
  }

    return (
        <div className="p-fluid grid formUnosZap">
            <div className="col-12">
                <Divider />
                  <div className="gridHeader">
                            <h4>Izbor vozila:</h4>
                       <CustomDropdown
                            style={{ width: "20%", marginLeft: '1%' }}
                            id="id_vehicle" 
                            name="id_vehicle" 
                            value={idVehicle} 
                            required
                            options={vehicleDB || []}
                            placeholder={t('admin.phRegistraciju')}
                            optionLabel="label"
                            onChange={selectIdVehicleFUNC}
                            onFocus={handleSelect}
                        />
                </div>
            </div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <form autoComplete="off"  ref={formRef}>
            <Accordion className='zaposleniDashboard' multiple activeIndex={[0]}>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.opstiPodaci')}>
                <div className="col-12 md:col-6">
                    <Card>
                         <div className="gridVehicleFirstReg" style={{marginBottom: '1%'}}>
                            <div className="red1 redDokument">
                               <div className="col-12">
                            <h4>KATEGORIJA</h4>
                                </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="vrstaVozila">{t('admin.vrstaVozila')}:</label>
                             <CustomDropdown
                                            id="VrstaVozila"
                                            name="VrstaVozila"
                                            value={formDataVehicle.VrstaVozila} 
                                            options={vrstaVozilaOptions}
                                            onChange={handleVehicleChange}
                                            placeholder={t('admin.phVrstuVozila')}
                                            required
                                            invalid={invalidControl(formDataVehicle.VrstaVozila)}
                                            optionLabel="label" // <--- ovo je ključno za prikaz naziva
                                        />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="VrstaNadgradnje">{t('admin.vrstaNadgradnje')}:</label>
                            <CustomDropdown
                                            id="VrstaNadgradnje"
                                            name="VrstaNadgradnje"
                                            value={formDataVehicle.VrstaVozila == null || formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila === 16 ? null : formDataVehicle.VrstaNadgradnje} 
                                            options={vrstaNadgradnjeOptions}
                                            disabled={formDataVehicle.VrstaVozila == null || formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? true : false }
                                            onChange={handleVehicleChange}
                                            placeholder={t('admin.phVrstuNadgradnje')}
                                            required={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? false : true}
                                            invalid={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? null : invalidControl(formDataVehicle.VrstaNadgradnje)}
                                            optionLabel="label" // <--- ovo je ključno za prikaz naziva
                                        />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="euroOznaka">{t('admin.euroOznaka')}:</label>
                            <Dropdown 
                                id="euroOznaka" 
                                name="EuroOznaka" 
                                required={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? true : false}
                                invalid={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? invalidControl(formDataVehicle.EuroOznaka) : null}
                                disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ||formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16 ? false : true }
                                value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ||formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16 ? formDataVehicle.EuroOznaka : null } 
                                options={euroStandardOptions} 
                                onChange={handleVehicleChange} 
                                placeholder={t('admin.phEuroOznaku')}
                            />
                        </div>
                        <div className="col-12 md:col-6">
                                <label htmlFor="pogonskoGorivo">{t('admin.pogonskoGorivo')}:</label>
                                <Dropdown placeholder={t('admin.phGorivo')} id="pogonskoGorivo"  
                                required={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? true : false}
                                invalid={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? invalidControl(formDataVehicle.PogonskoGorivo) : null}
                            
                                disabled={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 12 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 ? false : true }
                                name="PogonskoGorivo" 
                                value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ||formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16 ? formDataVehicle.PogonskoGorivo : null} 
                                options={pogonOptions} onChange={handleVehicleChange} />
                            </div>
                            </div>
                             <div className="red1 redDokument">
                                 <div className="col-12">
                                    <h4>DIMENZIJE VOZILA</h4>
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="duzina">{t('admin.duzina')}:</label>
                                    <InputText 
                                        id="duzina" 
                                        name="Duzina" 
                                        value={formDataVehicle.Duzina} 
                                        onChange={handleVehicleChange} 
                                        keyfilter="num" 
                                    />
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="sirina">{t('admin.sirina')}:</label>
                                    <InputText 
                                        id="sirina" 
                                        name="Sirina" 
                                        value={formDataVehicle.Sirina} 
                                        onChange={handleVehicleChange} 
                                        keyfilter="num" 
                                    />
                                </div>
                                <div className="col-12 md:col-4">
                                    <label htmlFor="visina">{t('admin.visina')}:</label>
                                    <InputText 
                                        id="visina" 
                                        name="Visina" 
                                        value={formDataVehicle.Visina} 
                                        onChange={handleVehicleChange} 
                                        keyfilter="num" 
                                    />
                                </div>
                            </div>
                         </div>
                        <div className="gridLicni gridVozilaOpsti">
                            <div className="col-12 md:col-6">
                                <label htmlFor="registracija">{t('login.tabRegistracija')}:</label>
                                <InputText required invalid={invalidControl(formDataVehicle.Registracija)} id="registracija" name="Registracija" value={formDataVehicle.Registracija} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="marka">{t('admin.marka')}:</label>
                                 <CustomDropdown
                                            id="Marka"
                                            name="Marka"
                                            value={formDataVehicle.Marka} 
                                            options={formDataVehicle.VrstaVozila == null || (formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 12) 
                                                ? markaVozilaOptions 
                                                : markaVozilaPrikljucnaOptions}
                                            onChange={handleVehicleChange}
                                            placeholder={t('admin.phMarku')}
                                            required
                                            invalid={invalidControl(formDataVehicle.Marka)}
                                            optionLabel="label" // <--- ovo je ključno za prikaz naziva
                                        />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="model">{t('admin.model')}:</label>
                                <InputText required id="model" name="Model" invalid={invalidControl(formDataVehicle.Model)} value={formDataVehicle.Model} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="godinaProizvodnje">{t('admin.godinaProizvodnje')}:</label>
                                <Calendar 
                                 showIcon 
                                dateFormat="yy"
                                view="year" mask="9999"
                                required
                                invalid={invalidControl(formDataVehicle.GodinaProizvodnje)} 
                                id="godinaProizvodnje" type="number" name="GodinaProizvodnje" value={formDataVehicle.GodinaProizvodnje} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="boja">{t('admin.boja')}:</label>
                                <InputText id="boja" name="Boja" value={formDataVehicle.Boja} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="sasija">{t('admin.sasija')}:</label>
                                <InputText id="sasija" name="Sasija" required invalid={invalidControl(formDataVehicle.Sasija)} value={formDataVehicle.Sasija} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="brojMotora">{t('admin.brojMotora')}:</label>
                                <InputText id="brojMotora" name="BrojMotora" required invalid={invalidControl(formDataVehicle.Sasija)} disabled={formDataVehicle.VrstaVozila == 10 || 
                                    formDataVehicle.VrstaVozila == 12 || formDataVehicle.VrstaVozila == 15 ? false : true} value={formDataVehicle.BrojMotora} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="snagaMotora">{t('admin.snagaMotora')}:</label>
                                <InputText id="snagaMotora" name="SnagaMotora" value={formDataVehicle.SnagaMotora} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="brojOsovina">{t('admin.brojOsovina')}:</label>
                                <InputText id="brojOsovina" name="BrojOsovina" value={formDataVehicle.BrojOsovina} type="number" onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="zapreminaMotora">{t('admin.zapreminaMotora')}:</label>
                                <InputText id="zapreminaMotora" name="ZapreminaMotora" value={formDataVehicle.ZapreminaMotora} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="masa">{t('admin.masaKg')}:</label>
                                <InputText id="masa" name="Masa" value={formDataVehicle.Masa} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="nosivost">{t('admin.nosivostKg')}:</label>
                                <InputText id="nosivost" name="Nosivost" disabled={formDataVehicle.VrstaVozila == 10 || formDataVehicle.VrstaVozila == 15 || formDataVehicle.VrstaVozila == 16 || formDataVehicle.VrstaVozila == 16 ? true: false} value={formDataVehicle.Nosivost} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="najvecaDozvoljenaMasa">{t('admin.najvecaMasa')}:</label>
                                <InputText id="najvecaDozvoljenaMasa" name="NajvecaDozvoljenaMasa" value={formDataVehicle.NajvecaDozvoljenaMasa} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="kapacitetRezervoara">{t('admin.kapacitetRez')}:</label>
                                <InputNumber id="kapacitetRezervoara" name="KapacitetRezervoara" value={formDataVehicle.KapacitetRezervoara} onValueChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="normiranaPotrosnja">{t('admin.normPotrosnja')}:</label>
                                <InputNumber id="normiranaPotrosnja" name="NormiranaPotrosnja"  mode="decimal"
                                minFractionDigits={1} value={formDataVehicle.NormiranaPotrosnja} onValueChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="kapacitetADBLUErez">{t('admin.kapacitetAdblue')}:</label>
                                <InputNumber id="kapacitetADBLUErez" name="KapacitetADBLUErez" value={formDataVehicle.KapacitetADBLUErez}  onValueChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="brojPecata">{t('admin.brojPecata')}:</label>
                                <InputNumber id="brojPecata" name="BrojPecata" value={formDataVehicle.BrojPecata}
                                    useGrouping={false} onValueChange={handleVehicleChange} />
                            </div>
                            <div className="col-12">
                                <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                <InputTextarea id="napomena" name="Napomena" value={formDataVehicle.Napomena} onChange={handleVehicleChange} rows={3} />
                            </div>
                        </div>
                    </Card>
                </div>
            </AccordionTab>
                    <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.prvaRegistracija')}>
            <div className="col-12 md:col-6">
                <Card>
                  
                    <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                               <div className="col-12">
                            <h4>OPŠTE</h4>
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="prvaRegDatum">{t('admin.datumPrveReg')}:</label>
                            <Calendar 
                                id="prvaRegDatum" 
                                name="PrvaRegistracijaDatum" 
                                value={formDataVehicleFirstReg.PrvaRegistracijaDatum} 
                                onChange={handleVehicleChange} 
                                showIcon 
                                dateFormat="dd.mm.yy" 
                                mask="99.99.9999"
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="prvaRegMesto">{t('admin.mesto')}:</label>
                            <InputText 
                                id="prvaRegMesto" 
                                name="PrvaRegistracijaMesto" 
                                value={formDataVehicleFirstReg.PrvaRegistracijaMesto} 
                                onChange={handleVehicleChange} 
                            />
                        </div>
                        
                        {/* REGISTARSKI PODACI */}
                        <div className="col-12 md:col-6">
                            <label htmlFor="registarskiBroj">{t('admin.registarskiBroj')}:</label>
                            <InputText 
                                id="registarskiBroj" 
                                name="RegistarskiBroj" 
                                value={formDataVehicleFirstReg.RegistarskiBroj} 
                                onChange={handleVehicleChange} 
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="brojSaobracajne">{t('admin.brojSaobracajne')}:</label>
                            <InputText 
                                id="brojSaobracajne" 
                                name="BrojSaobracajneDozvole" 
                                value={formDataVehicleFirstReg.BrojSaobracajneDozvole} 
                                onChange={handleVehicleChange} 
                            />
                        </div>
                            </div>
                         </div>
                   
                    <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                               <div className="col-12">
                            <h4>STARA REGISTRACIJA</h4>
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="vremenskiIntervalReg">{t('admin.staraReg')}:</label>
                            <InputText 
                                id="vremenskiIntervalReg" 
                                name="StaraRegistracija" 
                                value={formDataVehicleFirstReg.StaraRegistracija} 
                                onChange={handleVehicleChange} 
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="vremenskiIntervalRegOd">{t('ture.datumOd')}:</label>
                            <Calendar 
                                showIcon 
                                dateFormat="dd.mm.yy"
                                id="vremenskiIntervalRegOd" 
                                name="StaraRegistracijaIntervalOd" 
                                value={formDataVehicleFirstReg.StaraRegistracijaIntervalOd} 
                                onChange={handleVehicleChange} 
                                mask="99.99.9999"
                            />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="vremenskiIntervalReg">{t('ture.datumDo')}:</label>
                              {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                            <Calendar 
                                showIcon 
                                dateFormat="dd.mm.yy"
                                id="vremenskiIntervalRegDo" 
                                name="StaraRegistracijaIntervalDo" 
                                value={formDataVehicleFirstReg.StaraRegistracijaIntervalDo} 
                                onChange={handleVehicleChange} 
                                mask="99.99.9999"
                            />
                        </div>
                            </div>
                         </div>
                    <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                               <div className="col-12">
                            <h4>ISTEK SAOBRAĆAJNE</h4>
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="IstekSaobracajne">{t('admin.datumIsteka')}:</label>
                            <Calendar
                                id="IstekSaobracajne"
                                name="IstekSaobracajne"
                                value={formDataVehicleFirstReg.IstekSaobracajne}
                                onChange={handleVehicleChange}
                                showIcon
                                dateFormat="dd.mm.yy"
                                mask="99.99.9999"
                            />
                        </div>
                            <div className="col-12 md:col-6">
                                    <label htmlFor="SaobracajnaDokument">{t('admin.saobracajnaDok')}:</label>
                                    {formDataLicenceFiles.SaobracajnaDokument.length === 0 ? (
                                                                    <FileUpload
                                                                        className={buttonDocumentDB.SaobracajnaDokument && classDocumentDB}
                                                                        chooseLabel={buttonDocumentDB.SaobracajnaDokument ? natpisFajlaUBazi(buttonDocumentDB.SaobracajnaDokument) : "Izaberi"}
                                                                        name="SaobracajnaDokument"
                                                                        customUpload={false}
                                                                        auto={false}
                                                                        uploadLabel="Pošalji"
                                                                        mode="basic"
                                                                        accept=".pdf,.jpg,.png"
                                                                        maxFileSize={5000000}
                                                                        onSelect={(e) => handleChangeDocUpload("SaobracajnaDokument", e.files)}
                                                                    />
                                                                ) : (
                                                                    <div>
                                                                        {formDataLicenceFiles.SaobracajnaDokument.map((file, index) => (
                                                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                                                                                <span style={{ marginRight: '1%', flexGrow: 1 }}>{file.name}</span>
                                                                                <Button
                                                                                    icon="pi pi-times"
                                                                                    className="p-button-rounded p-button-danger p-button-text"
                                                                                    onClick={() => setFormDataLicenceFiles(prev => ({
                                                                                        ...prev,
                                                                                        SaobracajnaDokument: []
                                                                                    }))}
                                                                                    tooltip="Ukloni fajl"
                                                                                    tooltipOptions={{ position: 'top' }}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                </div>
                            <div className="col-12 md:col-6">
                                    <label htmlFor="NalepnicaDokument">{t('admin.nalepnicaDok')}:</label>
                                    {formDataLicenceFiles.NalepnicaDokument.length === 0 ? (
                                                                    <FileUpload
                                                                        className={buttonDocumentDB.NalepnicaDokument && classDocumentDB}
                                                                        chooseLabel={buttonDocumentDB.NalepnicaDokument ? natpisFajlaUBazi(buttonDocumentDB.NalepnicaDokument) : "Izaberi"}
                                                                        name="NalepnicaDokument"
                                                                        customUpload={false}
                                                                        auto={false}
                                                                        uploadLabel="Pošalji"
                                                                        mode="basic"
                                                                        accept=".pdf,.jpg,.png"
                                                                        maxFileSize={5000000}
                                                                        onSelect={(e) => handleChangeDocUpload("NalepnicaDokument", e.files)}
                                                                    />
                                                                ) : (
                                                                    <div>
                                                                        {formDataLicenceFiles.NalepnicaDokument.map((file, index) => (
                                                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                                                                                <span style={{ marginRight: '1%', flexGrow: 1 }}>{file.name}</span>
                                                                                <Button
                                                                                    icon="pi pi-times"
                                                                                    className="p-button-rounded p-button-danger p-button-text"
                                                                                    onClick={() => setFormDataLicenceFiles(prev => ({
                                                                                        ...prev,
                                                                                        NalepnicaDokument: []
                                                                                    }))}
                                                                                    tooltip="Ukloni fajl"
                                                                                    tooltipOptions={{ position: 'top' }}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                )}
                                                                </div>
                            </div>

                         </div>
                </Card>
            </div>
        </AccordionTab>
            <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.osiguranjeVozila')}>
                <div className="col-12 md:col-6">
                    <Card>
                        <div className="gridDokumentiOsiguranja">
                            {/* AO Osiguranje */}
                            <div className="red1 redDokument">
                                <div className="col-12">
                                    <h4>AO Osiguranje:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="aoDatumIsteka">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="aoDatumIsteka" name="AoDatumIsteka" value={formDataVehicleInsurance.AoDatumIsteka} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="aoBrojPolise">{t('admin.brojPolise')}:</label>
                                    <InputText id="aoBrojPolise" name="AoBrojPolise" value={formDataVehicleInsurance.AoBrojPolise} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="aoPremijskiStepen">{t('admin.premijskiStepen')}:</label>
                                    <InputNumber id="aoPremijskiStepen" name="AoPremijskiStepen" min={1} max={12} step={1} value={formDataVehicleInsurance.AoPremijskiStepen} 
                                        onValueChange={handleVehicleChange} keyfilter="num" />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="aoCenaPolise">{t('admin.cenaPolise')}:</label>
                                    <InputNumber id="aoCenaPolise" name="AoCenaPolise" value={formDataVehicleInsurance.AoCenaPolise} 
                                        onValueChange={handleVehicleChange} mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="aoDokument">{t('admin.viseDokumenta')}:</label>
                                    {formDataInsuranceFiles.AoDokument.length === 0 ? (
                                                                    <FileUpload
                                                                        name="AoDokument"
                                                                        className={buttonDocumentDB.AoDokument && classDocumentDB}
                                                                        chooseLabel={buttonDocumentDB.AoDokument ? natpisFajlaUBazi(buttonDocumentDB.AoDokument) : "Izaberi"}
                                                                        customUpload={false}
                                                                        multiple
                                                                        auto={false}
                                                                        uploadLabel="Pošalji"
                                                                        mode="basic"
                                                                        accept=".pdf,.jpg,.png"
                                                                        maxFileSize={5000000}
                                                                        onSelect={(e) => handleChangeDocUpload("AoDokument", e.files)}
                                                                    />
                                                                ) : (
                                                                    <div>
                                                                        {formDataInsuranceFiles.AoDokument.map((file, index) => (
                                                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '0.5rem' }}>
                                                                                <span style={{ marginRight: '1%', flexGrow: 1 }}>{file.name}</span>
                                                                                <Button 
                                                                                    icon="pi pi-times" 
                                                                                    className="p-button-rounded p-button-danger p-button-text"
                                                                                    onClick={() => {
                                                                                        const updatedFiles = [...formDataInsuranceFiles.AoDokument];
                                                                                        updatedFiles.splice(index, 1);
                                                                                        setFormDataInsuranceFiles(prev => ({
                                                                                            ...prev,
                                                                                            AoDokument: updatedFiles
                                                                                        }));
                                                                                    }}
                                                                                    tooltip="Ukloni fajl"
                                                                                    tooltipOptions={{ position: 'top' }}
                                                                                />
                                                                            </div>
                                                                        ))}
                                                                        
                                                                        <Button 
                                                                            label={t('ture.obrisiSve')} 
                                                                            onClick={() => setFormDataInsuranceFiles(prev => ({
                                                                                ...prev,
                                                                                AoDokument: []
                                                                            }))} 
                                                                            className="p-button-text p-button-danger"
                                                                            style={{ marginTop: '1rem' }}
                                                                        />
                                                                    </div>
                                                                )}
                                                                </div>
                                
                            </div>

                            {/* Zelena karta */}
                            <div className="red2 redDokument">
                                <div className="col-12">
                                    <h4>Zelena karta:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="zelenaKartaIstek">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="zelenaKartaIstek" name="ZelenaKartaIstek" value={formDataVehicleInsurance.ZelenaKartaIstek} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="zelenaKartaBroj">{t('admin.brojZelene')}:</label>
                                    <InputText id="zelenaKartaBroj" name="ZelenaKartaBroj" value={formDataVehicleInsurance.ZelenaKartaBroj} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="zelenaKartaCena">{t('admin.cenaPolise')}:</label>
                                    <InputNumber id="zelenaKartaCena" name="ZelenaKartaCena" value={formDataVehicleInsurance.ZelenaKartaCena} 
                                        onValueChange={handleVehicleChange}  mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="zelenaKartaDokument">{t('nova.dokument')}:</label>
                                    {!formDataInsuranceFiles.ZelenaKartaDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.ZelenaKartaDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.ZelenaKartaDokument ? natpisFajlaUBazi(buttonDocumentDB.ZelenaKartaDokument) : "Izaberi"}
                                            name="ZelenaKartaDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("ZelenaKartaDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataInsuranceFiles.ZelenaKartaDokument.name} 
                                            onClick={() => handleChangeDocUpload("ZelenaKartaDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>

                            {/* Osiguranje stakla */}
                            <div className="red3 redDokument">
                                <div className="col-12">
                                    <h4>Osiguranje stakla:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="stakloIstek">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="stakloIstek" name="StakloIstek" value={formDataVehicleInsurance.StakloIstek} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="stakloBrojPolise">{t('admin.brojPolise')}:</label>
                                    <InputText id="stakloBrojPolise" name="StakloBrojPolise" value={formDataVehicleInsurance.StakloBrojPolise} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="stakloPremijskiStepen">{t('admin.premijskiStepen')}:</label>
                                    <InputNumber id="stakloPremijskiStepen" name="StakloPremijskiStepen"  min={1} max={12} step={1} value={formDataVehicleInsurance.StakloPremijskiStepen} 
                                        onValueChange={handleVehicleChange} keyfilter="num" />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="stakloDokument">{t('nova.dokument')}:</label>
                                    {!formDataInsuranceFiles.StakloDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.StakloDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.StakloDokument ? natpisFajlaUBazi(buttonDocumentDB.StakloDokument) : "Izaberi"}
                                            name="StakloDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("StakloDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataInsuranceFiles.StakloDokument.name} 
                                            onClick={() => handleChangeDocUpload("stakloDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>
                            {/* Strahovka */}
                             <div className="red4 redDokument">
                                <div className="col-12">
                                    <h4>STRAHOVKA osiguranje:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="strahovkaIstek">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="strahovkaIstek" name="StrahovkaIstek" value={formDataVehicleInsurance.StrahovkaIstek} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="StrahovkaBroj">{t('admin.brojOsig')}:</label>
                                    <InputText id="StrahovkaBroj" name="StrahovkaBroj" value={formDataVehicleInsurance.StrahovkaBroj} 
                                        onChange={handleVehicleChange} />
                                </div>     
                                <div className="col-12 md:col-6">
                                    <label htmlFor="StrahovkaCena">{t('admin.cenaPolise')}:</label>
                                    <InputNumber id="StrahovkaCena" name="StrahovkaCena" value={formDataVehicleInsurance.StrahovkaCena} 
                                        onValueChange={handleVehicleChange} mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"}  minFractionDigits={2} maxFractionDigits={2}/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="StrahovkaDokument">{t('nova.dokument')}:</label>
                                    {!formDataInsuranceFiles.StrahovkaDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.StrahovkaDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.StrahovkaDokument ? natpisFajlaUBazi(buttonDocumentDB.StrahovkaDokument) : "Izaberi"}
                                            name="StrahovkaDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("StrahovkaDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataInsuranceFiles.StrahovkaDokument.name} 
                                            onClick={() => handleChangeDocUpload("StrahovkaDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>
                            {/* Kasko osiguranje */}
                            <div className="red5 redDokument">
                                <div className="col-12">
                                    <h4>Kasko osiguranje:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoIstek">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="kaskoIstek" name="KaskoIstek" value={formDataVehicleInsurance.KaskoIstek} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoBrojPolise">{t('admin.brojPolise')}:</label>
                                    <InputText id="kaskoBrojPolise" name="KaskoBrojPolise" value={formDataVehicleInsurance.KaskoBrojPolise} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoStete">{t('admin.stetePolisi')}:</label>
                                    <InputNumber id="kaskoStete" name="KaskoStete" value={formDataVehicleInsurance.KaskoStete} 
                                        onValueChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoCena">{t('admin.cenaPolise')}:</label>
                                    <InputNumber id="kaskoCena" name="KaskoCena" value={formDataVehicleInsurance.KaskoCena} 
                                        onValueChange={handleVehicleChange}  mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoUcesce">{t('admin.ucesce')}:</label>
                                    <InputNumber id="kaskoUcesce" prefix="%" name="KaskoUcesce" min={1} max={100} step={1} value={formDataVehicleInsurance.KaskoUcesce} 
                                        onValueChange={handleVehicleChange} keyfilter="num" />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="kaskoDokument">{t('nova.dokument')}:</label>
                                    {!formDataInsuranceFiles.KaskoDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.KaskoDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.KaskoDokument ? natpisFajlaUBazi(buttonDocumentDB.KaskoDokument) : "Izaberi"}
                                            name="KaskoDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("KaskoDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataInsuranceFiles.KaskoDokument.name} 
                                            onClick={() => handleChangeDocUpload("KaskoDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>

                            {/* CMR osiguranje */}
                            {formDataVehicle.VrstaVozila == 11 || formDataVehicle.VrstaVozila == 12 ||formDataVehicle.VrstaVozila == 13 || formDataVehicle.VrstaVozila == 14 ? <div className="red6 redDokument">
                                <div className="col-12">
                                    <h4>CMR osiguranje:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrIstek">{t('admin.datumIsteka')}:</label>
                                    <Calendar id="cmrIstek" name="CmrIstek" value={formDataVehicleInsurance.CmrIstek} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrBrojPolise">{t('admin.brojPolise')}:</label>
                                    <InputText id="cmrBrojPolise" name="CmrBrojPolise" value={formDataVehicleInsurance.CmrBrojPolise} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrStete">{t('admin.stetePolisi')}:</label>
                                    <InputText id="cmrStete" name="CmrStete" value={formDataVehicleInsurance.CmrStete} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrCena">{t('admin.cenaPolise')}:</label>
                                    <InputNumber id="cmrCena" name="CmrCena" value={formDataVehicleInsurance.CmrCena} 
                                        onChange={handleVehicleChange} mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrUcesce">{t('admin.ucesce')}:</label>
                                    <InputNumber id="cmrUcesce" name="CmrUcesce" prefix="%" min={1} max={100} step={1}  value={formDataVehicleInsurance.CmrUcesce} 
                                        onChange={handleVehicleChange} keyfilter="num" />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="cmrDokument">{t('nova.dokument')}:</label>
                                    {!formDataInsuranceFiles.CmrDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.CmrDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.CmrDokument ? natpisFajlaUBazi(buttonDocumentDB.CmrDokument) : "Izaberi"}
                                            name="CmrDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("CmrDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataInsuranceFiles.CmrDokument.name} 
                                            onClick={() => handleChangeDocUpload("CmrDokument", null)} 
                                        />
                                    }
                                </div>
                            </div> : null}
                            
                        </div>
                    </Card>
                </div>
            </AccordionTab>
              <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.vazniDatumi')}>
                <div className="col-12 md:col-6">
                    <Card>
                        <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                                <div className="col-12">
                                    <h4>CEMT (Bela potvrda):</h4>
                                </div>
                                 <div className="col-12 md:col-6">
                                    <label htmlFor="CemtBelaPotvrda">{t('admin.brojCemt')}:</label>
                                    <InputText id="CemtBelaPotvrda" name="CemtBelaPotvrda" value={formDataVehicleImportantDates.CemtBelaPotvrda} 
                                        onChange={handleVehicleChange} />
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="CemtBelaPotvrdaVaziDo">{t('admin.datumIstekaPot')}:</label>
                                    <Calendar id="CemtBelaPotvrdaVaziDo" name="CemtBelaPotvrdaVaziDo" value={formDataVehicleImportantDates.CemtBelaPotvrdaVaziDo} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="CemtBelaPotvrdaDokument">{t('nova.dokument')}:</label>
                                    {!formDataImportantDatesFiles.CemtBelaPotvrdaDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.CemtBelaPotvrdaDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.CemtBelaPotvrdaDokument ? natpisFajlaUBazi(buttonDocumentDB.CemtBelaPotvrdaDokument) : "Izaberi"}
                                            name="CemtBelaPotvrdaDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("CemtBelaPotvrdaDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataImportantDatesFiles.CemtBelaPotvrdaDokument.name} 
                                            onClick={() => handleChangeDocUpload("CemtBelaPotvrdaDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>

                            {/* CEMT */}
                            <div className="red2 redDokument">
                                <div className="col-12">
                                    <h4>CEMT sertifikat:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="CemtDokument">{t('nova.dokument')}:</label>
                                    {!formDataImportantDatesFiles.CemtDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.CemtDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.CemtDokument ? natpisFajlaUBazi(buttonDocumentDB.CemtDokument) : "Izaberi"}
                                            name="CemtDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("CemtDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataImportantDatesFiles.CemtDokument.name} 
                                            onClick={() => handleChangeDocUpload("CemtDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>

                            {/* Izvod licence — jedan upload, isti oblik kao CEMT sertifikat */}
                            <div className="red2 redDokument">
                                <div className="col-12">
                                    <h4>{t('admin.izvodLicence')}:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="IzvodLicenceDokument">{t('nova.dokument')}:</label>
                                    {!formDataImportantDatesFiles.IzvodLicenceDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.IzvodLicenceDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.IzvodLicenceDokument ? natpisFajlaUBazi(buttonDocumentDB.IzvodLicenceDokument) : "Izaberi"}
                                            name="IzvodLicenceDokument"
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("IzvodLicenceDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataImportantDatesFiles.IzvodLicenceDokument.name} 
                                            onClick={() => handleChangeDocUpload("IzvodLicenceDokument", null)} 
                                        />
                                    }
                                </div>
                            </div>

                            {/* Tir */}
                            <div className="red3 redDokument">
                                <div className="col-12">
                                    <h4>{t('admin.tirSert')}:</h4>
                                </div>
                                 <div className="col-12 md:col-6">
                                    <label htmlFor="TirSertifikat">{t('admin.tirSert')}:</label>
                                    <InputText id="TirSertifikat" name="TirSertifikat" value={formDataVehicleImportantDates.TirSertifikat} 
                                        onChange={handleVehicleChange} />
                                </div>
                                  <div className="col-12 md:col-6">
                                    <label htmlFor="TirSertifikatVaziDo">{t('admin.datumIstekaTir')}:</label>
                                    <Calendar id="TirSertifikatVaziDo" name="TirSertifikatVaziDo" value={formDataVehicleImportantDates.TirSertifikatVaziDo} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                            </div>

                             {/* Tehnicki */}
                            <div className="red4 redDokument">
                                <div className="col-12">
                                    <h4>Tehnički pregled:</h4>
                                </div>
                             <div className="col-12 md:col-6">
                                    <label htmlFor="Sestomesecni">{t('admin.rokSestomesecni')}:</label>
                                    <Calendar id="Sestomesecni" name="Sestomesecni" value={formDataVehicleImportantDates.Sestomesecni} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                 <div className="col-12 md:col-6">
                                    <label htmlFor="ObnovaTehnickog">{t('admin.datumTehPregleda')}:</label>
                                    <Calendar id="ObnovaTehnickog" name="ObnovaTehnickog" value={formDataVehicleImportantDates.ObnovaTehnickog} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                            </div>
                            {/* TAHO */}
                            <div className="red2 redDokument">
                                <div className="col-12">
                                    <h4>Sertifikat tahografa:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="TahoSertifikat">{t('admin.datumVazenjaTaho')}:</label>
                                    <Calendar id="TahoSertifikat" name="TahoSertifikat" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? false : true }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.TahoSertifikat : null } 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="TahoSertifikatDokument">{t('nova.dokument')}:</label>
                                    {!formDataImportantDatesFiles.TahoSertifikatDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.TahoSertifikatDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.TahoSertifikatDokument ? natpisFajlaUBazi(buttonDocumentDB.TahoSertifikatDokument) : "Izaberi"}
                                            name="TahoSertifikatDokument"
                                            disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? false : true }
                                            uploadLabel="Pošalji"
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("TahoSertifikatDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataImportantDatesFiles.TahoSertifikatDokument.name} 
                                            onClick={() => handleChangeDocUpload("TahoSertifikatDokument", null)} 
                                        />
                                    }
                                </div>
                            </div> 
                                 
                                   {/* Ostalo */}
                            <div className="red4 redDokument">
                                <div className="col-12">
                                    <h4>Ostala dokumenta:</h4>
                                </div>
                               <div className="col-12 md:col-6">
                                    <label htmlFor="LPaket">{t('admin.lPaket')}:</label>
                                    <Calendar id="LPaket" name="LPaket" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? false : true }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.LPaket : null } 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="LpaketDokument">{t('admin.lPaketDok')}:</label>
                                    {!formDataImportantDatesFiles.LpaketDokument ? 
                                        <FileUpload
                                            className={buttonDocumentDB.LpaketDokument && classDocumentDB}
                                            chooseLabel={buttonDocumentDB.LpaketDokument ? natpisFajlaUBazi(buttonDocumentDB.LpaketDokument) : "Izaberi"}
                                            name="LpaketDokument"
                                            uploadLabel="Pošalji"
                                            disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? false : true }
                                            mode="basic"
                                            accept=".pdf,.jpg,.png"
                                            maxFileSize={5000000}
                                            onSelect={(e) => handleChangeDocUpload("LpaketDokument", e.files[0])}
                                        /> : 
                                        <Button 
                                            label={formDataImportantDatesFiles.LpaketDokument.name} 
                                            onClick={() => handleChangeDocUpload("LpaketDokument", null)} 
                                        />
                                    }
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="PPaparat">{t('admin.ppAparat')}:</label>
                                    <Calendar id="PPaparat" name="PPaparat"
                                    value={formDataVehicleImportantDates.PPaparat}
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="PrvaPomoc">{t('admin.prvaPomoc')}:</label>
                                    <Calendar id="PrvaPomoc" name="PrvaPomoc"
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? false : true }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.PrvaPomoc : null }
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                              <div className="col-12 md:col-6">
                                    <label htmlFor="FRCSertifikat">{t('admin.frcSert')}:</label>
                                    <Calendar id="FRCSertifikat" name="FRCSertifikat" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.FRCSertifikat : null }
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="FNXSertifikat">{t('admin.fnxSert')}:</label>
                                    <Calendar id="FNXSertifikat" name="FNXSertifikat"
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.FNXSertifikat : null }
                             
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                   <div className="col-12 md:col-6">
                                    <label htmlFor="Mapiranje">{t('admin.mapiranje')}:</label>
                                    <Calendar id="Mapiranje" name="Mapiranje" 
                                     disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.Mapiranje : null }
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                   <div className="col-12 md:col-6">
                                    <label htmlFor="Etaloniranje">{t('admin.etaloniranje')}:</label>
                                    <Calendar id="Etaloniranje" name="Etaloniranje"
                                      disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false }
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? formDataVehicleImportantDates.Etaloniranje : null } 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="CODEXL">{t('admin.codeXl')}:</label>
                                    <Calendar id="CODEXL" name="CODEXL" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || (formDataVehicle.VrstaVozila === 12 && formDataVehicle.VrstaNadgradnje !== 272 && formDataVehicle.VrstaNadgradnje !== 22 ) ? true : false }
                                    value={formDataVehicle.VrstaVozila === 10 || (formDataVehicle.VrstaVozila === 12 && formDataVehicle.VrstaNadgradnje !== 272 && formDataVehicle.VrstaNadgradnje !== 22 ) ? formDataVehicleImportantDates.CODEXL : null } 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                            </div>

                        </div>
                    </Card>
                </div>
            </AccordionTab>
            {/* ── VINJETE ───────────────────────────────────────────────────
                Zaseban tab, a ne deo "Vaznih datuma": tamo je kartica siroka
                pola ekrana (col-12 md:col-6), pa se tabela svih vinjeta stiskala
                u uzak stubac sa klizacem i kolone su se lomile.

                Vozilo drzi VISE vinjeta, po jednu za svaku zemlju — zato forma
                gore, spisak dole, i sve u punoj sirini. */}
            <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.vinjete')}>
                <div className="col-12">
                    <Card>
                        <div className="gridLicni kretanja" style={{ gap: '1rem', alignItems: 'flex-end' }}>
                            <div className="col-12 md:col-3 kretanja_inputi" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="VinjetaDrzava">{t('admin.drzava')}:</label>
                                <CustomDropdown
                                    id="VinjetaDrzava"
                                    name="VinjetaDrzava"
                                    style={{ width: '100%' }}
                                    optionLabel="label"
                                    value={vinjetaForma.id_drzava}
                                    options={drzaveVinjeta || []}
                                    placeholder={t('admin.phDrzava')}
                                    onChange={(e) => setVinjetaForma(prev => ({ ...prev, id_drzava: e.target.value }))}
                                />
                            </div>
                            <div className="col-12 md:col-3 kretanja_inputi" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="VinjetaDatum">{t('admin.vinjetaIstice')}:</label>
                                <Calendar id="VinjetaDatum" name="VinjetaDatum"
                                    value={vinjetaForma.DatumIsteka}
                                    onChange={(e) => setVinjetaForma(prev => ({ ...prev, DatumIsteka: e.value }))}
                                    showIcon dateFormat="dd.mm.yy" mask="99.99.9999" />
                            </div>
                            <div className="col-12 md:col-4 kretanja_inputi" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="VinjetaNapomena">{t('nova.napomena')}:</label>
                                <InputText id="VinjetaNapomena" name="VinjetaNapomena" maxLength={500}
                                    style={{ width: '100%' }}
                                    value={vinjetaForma.Napomena}
                                    onChange={(e) => setVinjetaForma(prev => ({ ...prev, Napomena: e.target.value }))} />
                            </div>
                            <div className="col-12 md:col-2" style={{ display: 'flex', gap: '0.5rem' }}>
                                <Button type="button" severity="success"
                                    label={vinjetaForma.id ? t('common.save') : t('common.unos')}
                                    onClick={sacuvajVinjetu} />
                                {vinjetaForma.id && (
                                    <Button type="button" severity="danger" outlined
                                        label={t('common.delete')} onClick={obrisiVinjetu} />
                                )}
                            </div>
                        </div>
                    </Card>
                    <Card style={{ marginTop: '1%' }}>
                        {/* Istekla vinjeta se NE krije — negativan broj dana je takodje
                            podatak, i to onaj zbog kog se ovaj spisak i gleda. */}
                        <DataTable value={vinjete || []} size="small"
                            paginator rows={10} scrollable scrollHeight="40vh"
                            resizableColumns columnResizeMode="expand"
                            className="turePregledTable"
                            emptyMessage={idVehicle ? t('admin.vinjetaNema') : t('admin.vinjetaBezVozila')}
                            rowClassName={r => String(r?.Izaberi) === String(vinjetaForma.id) ? { 'selected-row': true } : {}}>
                            <Column header={t('common.choose')} style={{ minWidth: '110px' }}
                                body={(red) => (
                                    <Button label={t('common.choose')} icon="pi pi-eye" type="button"
                                        className="p-button-text p-button-sm"
                                        onClick={() => izaberiVinjetu(red)} />
                                )} />
                            <Column field="Država" header={t('admin.drzava')} sortable style={{ minWidth: '180px' }} />
                            <Column field="Oznaka" header={t('admin.oznakaDrzave')} style={{ minWidth: '100px' }} />
                            <Column field="Ističe" header={t('admin.vinjetaIstice')} sortable style={{ minWidth: '140px' }} />
                            <Column field="DanaDoIsteka" header={t('admin.danaDoIsteka')} sortable style={{ minWidth: '140px' }}
                                body={(r) => (r?.DanaDoIsteka == null ? '-' : r.DanaDoIsteka)} />
                            <Column field="Napomena" header={t('nova.napomena')} style={{ minWidth: '220px' }} />
                        </DataTable>
                    </Card>
                </div>
            </AccordionTab>
             <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.dodatnaOprema')}>
                <div className="col-12 md:col-6">
                    <Card>
                        <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                                <div className="col-12">
                                    <h4>ADR oprema:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="ADRDatumIsteka">{t('admin.datumIstekaOpr')}:</label>
                                    <Calendar id="ADRDatumIsteka" name="ADRDatumIsteka" value={formDataVehicleAdditional.ADRDatumIsteka} 
                                        onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                            </div>
                              <div className="red2 redDokument">
                                <div className="col-12">
                                    <h4>Zaduženje:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="PregledOpreme">{t('admin.pregledOpreme')}:</label>
                                    <InputText id="PregledOpreme" name="PregledOpreme" value={formDataVehicleAdditional.PregledOpreme} 
                                        onChange={handleVehicleChange}/>
                                </div>

                                <div className="col-12 md:col-6">
                                    <label htmlFor="ZaduzioVozac">{t('admin.zaduzujeVozac')}:</label>
                                    {/* Padajuci spisak, ne AutoComplete: kolona ZaduzioVozac je INT,
                                        a procedura cuva id vozaca (JSON_VALUE ... AS INT). AutoComplete
                                        je ovde upisivao ceo objekat, pa se izbor nije ni snimao — a
                                        spisak se ni nije pojavljivao, jer je trazio polje Naziv dok je
                                        procedura vracala Vozac. Dropdown salje baš id. */}
                                    <CustomDropdown
                                        style={{ width: "100%", margin: '0' }}
                                        id="ZaduzioVozac"
                                        name="ZaduzioVozac"
                                        value={formDataVehicleAdditional.ZaduzioVozac}
                                        options={driverDB || []}
                                        optionLabel="label"
                                        placeholder={t('ture.phVozaca')}
                                        onChange={handleVehicleChange}
                                    />
                                </div>

                            </div>


                            <div className="red3 redDokument">
                                <div className="col-12">
                                    <h4>Frigo oprema:</h4>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="FrigoUredjaj">{t('admin.frigoUredjaj')}:</label>
                                    <InputText 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.FrigoUredjaj } 
                                    id="FrigoUredjaj" name="FrigoUredjaj" 
                                        onChange={handleVehicleChange}/>
                                </div>
                                 <div className="col-12 md:col-6">
                                    <label htmlFor="FrigoUredjajModel">{t('admin.frigoModel')}:</label>
                                    <InputText id="FrigoUredjajModel" name="FrigoUredjajModel" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.FrigoUredjajModel }  
                                        onChange={handleVehicleChange}/>
                                </div>
                               <div className="col-12 md:col-6">
                                    <label htmlFor="GodinaProizvodnjeFrigo">{t('admin.godinaProizvodnjeFrigo')}:</label>
                                    <Calendar id="GodinaProizvodnjeFrigo" name="GodinaProizvodnjeFrigo" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.GodinaProizvodnjeFrigo } 
                                        onChange={handleVehicleChange} showIcon view="year" dateFormat="yy" mask="9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="SerijskiBrojFrigo">{t('admin.frigoSerijski')}:</label>
                                    <InputText id="SerijskiBrojFrigo" name="SerijskiBrojFrigo" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.SerijskiBrojFrigo }  
                                        onChange={handleVehicleChange}/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="TermoPisac">{t('admin.termoPisac')}:</label>
                                    <InputText id="TermoPisac" name="TermoPisac" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.TermoPisac }  
                                        onChange={handleVehicleChange}/>
                                </div>
                               <div className="col-12 md:col-6">
                                    <label htmlFor="GodinaProizvodnjePisac">{t('admin.godinaProizvodnjeTermo')}:</label>
                                    <Calendar id="GodinaProizvodnjePisac" name="GodinaProizvodnjePisac" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.GodinaProizvodnjePisac } 
                                        onChange={handleVehicleChange} showIcon view="year" dateFormat="yy" mask="9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="SerijskiBrojPisac">{t('admin.frigoSerijski')}:</label>
                                    <InputText id="SerijskiBrojPisac" name="SerijskiBrojPisac" 
                                    disabled={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 12 ? true : false}
                                    value={formDataVehicle.VrstaVozila === 10 || formDataVehicle.VrstaVozila === 15 || formDataVehicle.VrstaVozila === 16  ? null : formDataVehicleAdditional.SerijskiBrojPisac }  
                                        onChange={handleVehicleChange}/>
                                </div>
                            </div>
                        </div>
                    </Card>
                </div>
            </AccordionTab>
            <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.nabavkaVozila')}>
                <div className="col-12 md:col-6">
                    <Card>
                        <div className="gridLicni" style={{marginBottom: '1%'}}>
                               <div className="col-12 md:col-6">
                                <label htmlFor="vlasnistvo">{t('admin.vlasnistvo')}:</label>
                                <CustomDropdown
                                            id="Vlasnistvo"
                                            name="Vlasnistvo"
                                            value={formDataVehicleProcurement.Vlasnistvo} 
                                            options={tipVlasnistvaOptions}
                                            onChange={handleVehicleChange}
                                            placeholder={t('admin.phVlasnistvo')}
                                            required
                                            invalid={invalidControl(formDataVehicleProcurement.Vlasnistvo)}
                                            optionLabel="label" // <--- ovo je ključno za prikaz naziva
                                        />
                            </div>
                            <div className="col-12 md:col-6">
                                    <label htmlFor="PregledOpreme">{t('admin.lizingKucaZakup')}:</label>
                                       <AutoComplete
                                    style={{ width: "100%", margin:'0' }}
                                    type="text"
                                    className="Naziv"
                                    invalid={invalidControl(formDataVehicleProcurement.LizingKuca)}
                                    value={formDataVehicleProcurement.LizingKuca}
                                    placeholder={t('admin.lizingKuca')}
                                    required
                                    disabled={formDataVehicleProcurement.Vlasnistvo == 58 ? true : false}
                                    name="LizingKuca"
                                    suggestions={filteredClient}
                                    completeMethod={searchClient}
                                    field="Naziv"
                                    onSelect={selectLizingKucaFUNC}
                                    />
                                    
                                </div>       
                            <div className="col-12 md:col-6">
                                <label htmlFor="Rate">{t('admin.rate')}:</label>
                                <InputNumber id="Rate" name="Rate" required invalid={invalidControl(formDataVehicleProcurement.Rate)} disabled={formDataVehicleProcurement.Vlasnistvo == 58 ? true : false} value={formDataVehicleProcurement.Rate} onValueChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="brojLizingUgovora">{t('admin.brojLizing')}:</label>
                                <InputText id="brojLizingUgovora" required invalid={invalidControl(formDataVehicleProcurement.BrojLizingUgovora)} disabled={formDataVehicleProcurement.Vlasnistvo == 58 ? true : false} name="BrojLizingUgovora" value={formDataVehicleProcurement.BrojLizingUgovora} onChange={handleVehicleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumIstekaLizinga">{t('admin.datumIstekaLiz')}:</label>
                                <Calendar id="datumIstekaLizinga" mask="99.99.9999" required invalid={invalidControl(formDataVehicleProcurement.DatumIstekaLizinga)} disabled={formDataVehicleProcurement.Vlasnistvo == 58 ? true : false} name="DatumIstekaLizinga" value={formDataVehicleProcurement.DatumIstekaLizinga} onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="cena">{t('ture.cena')}:</label>
                                <InputNumber id="cena" name="Cena" value={formDataVehicleProcurement.Cena} onValueChange={handleVehicleChange} mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="iznosPDV">{t('admin.iznosPdv')}:</label>
                                 <InputNumber id="IznosPDV" name="IznosPDV" value={formDataVehicleProcurement.IznosPDV} onValueChange={handleVehicleChange} mode="currency" currency={company.companyState == "Srbija" ? "RSD" : "EUR"} minFractionDigits={2} maxFractionDigits={2} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumNabavke">{t('admin.datumNabavke')}:</label>
                                <Calendar id="datumNabavke" mask="99.99.9999" name="DatumNabavke" value={formDataVehicleProcurement.DatumNabavke} onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" />
                            </div> 
                            <div className="col-12 md:col-6">
                                <label htmlFor="datumIstekaGarancije">{t('admin.datumIstekaGar')}:</label>
                                <Calendar id="datumIstekaGarancije" mask="99.99.9999" name="DatumIstekaGarancije" value={formDataVehicleProcurement.DatumIstekaGarancije} onChange={handleVehicleChange} showIcon dateFormat="dd.mm.yy" />
                            </div> 
                             <div className="col-12 md:col-6">
                                <label htmlFor="istekGarancijeKm">{t('admin.istekGarancijeKM')}:</label>
                                <InputText id="istekGarancijeKm" type="number" name="IstekGarancijeKm" value={formDataVehicleProcurement.IstekGarancijeKm} onChange={handleVehicleChange} />
                            </div>
                             <div className="col-12 md:col-6">
                                    <label htmlFor="nabavkaOd">{t('admin.nabavkaOd')}:</label>
                                       <AutoComplete
                                    style={{ width: "100%", margin:'0' }}
                                    type="text"
                                    className="Naziv"
                                    value={formDataVehicleProcurement.NabavkaOd}
                                    placeholder={t('admin.nabavkaOd')}
                                    name="NabavkaOd"
                                    suggestions={filteredClient}
                                    completeMethod={searchClient}
                                    field="Naziv"
                                    onSelect={selectNabavkaOdFUNC}
                                    />
                                </div>     
                        </div>
                        <div className="gridVehicleFirstReg">
                            <div className="red1 redDokument">
                               <div className="col-12">
                                    <h4>{t('admin.amortizacija')}</h4>
                                </div>
                                    
                                    <div className="col-12 md:col-6">
                                    <label htmlFor="amortizacioniKMkoficijent">{t('admin.amortKoef')}:</label>
                                    <InputNumber
                                        id="amortizacioniKMkoficijent"
                                        required
                                        invalid={invalidControl(formDataVehicleProcurement.AmortizacioniKMkoficijent)}
                                        mode="decimal"
                                        min={0}
                                        step={0.01}
                                        max={1}
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        name="AmortizacioniKMkoficijent"
                                        disabled={!formDataVehicleProcurement.Amortizacija || formDataVehicleProcurement.AmortizacijaPoKM}
                                        value={formDataVehicleProcurement.AmortizacioniKMkoficijent}
                                        onValueChange={handleVehicleChange}
                                    />
                                    </div>

                                    <div className="col-12 md:col-6">
                                    <label htmlFor="amortizacijaPoKM">{t('admin.amortizacijaKM')}:</label>
                                    <InputNumber 
                                        id="amortizacijaPoKM" 
                                        name="AmortizacijaPoKM"  
                                        required 
                                        invalid={invalidControl(formDataVehicleProcurement.AmortizacijaPoKM)} 
                                        disabled={!formDataVehicleProcurement.Amortizacija || formDataVehicleProcurement.AmortizacioniKMkoficijent}
                                        value={formDataVehicleProcurement.AmortizacijaPoKM} 
                                        onValueChange={handleVehicleChange} 
                                    />
                                    </div>
                                    <div className="col-12 md:col-6">
                                    <label htmlFor="amortizacija">{t('admin.amortizacija')}:</label>
                                    <Checkbox 
                                        id="amortizacija" 
                                        name="Amortizacija" 
                                        checked={formDataVehicleProcurement.Amortizacija} 
                                        onChange={handleVehicleChange} 
                                    />
                                    </div>

                            </div>
                        </div>
                    </Card>
                </div>
            </AccordionTab>
            </Accordion>
           
            
           <div className="formUnosZap buttonUnosZap">
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="btn btn-success"
              >
                {izabran ? 'SAČUVAJ' : 'UNOS' }
              </button>
            </div>
            </form>
        </div>
    );
};

export default VozilaUnos;